import { createSlice } from "@reduxjs/toolkit";

export const reviewsSlice = createSlice({
    name: 'reviews',

    initialState: {

        payload: {}
    },
    reducers: {
        reviews: (state, action) => {
           state.payload = action.payload
        },
    }
});

export const {reviews} = reviewsSlice.actions
export default reviewsSlice.reducer